import { OrderDetail } from "app/+core/common/model/order-detail.model";
import { ProductOrder } from "app/+core/common/model/product-order.model";
import { OrderPhase } from "app/+core/common/model/order-phase.model";

export class Order {
    id: number;
    date: Date;
    deliveryDate: Date;
    creationDate: Date;
    number: string;
    description: string;
    orderPhaseId: number;
    renterId: number;
    orderDetails: OrderDetail[];
    productOrders: ProductOrder[];
    orderPhase: OrderPhase
    structureId: number;
    structureName: string;
    isopen: boolean;

    constructor() {
        this.id = 0;
        this.date = new Date();
        this.creationDate = new Date();
        this.orderDetails = [];
        this.productOrders = [];
        this.orderPhase = new OrderPhase();
        this.structureName = "";
        this.isopen = false
    }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/order.model.ts